import React, { useEffect, useState } from 'react';
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'
import { Grid } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TablePagination from '@mui/material/TablePagination';
import Stack from '@mui/material/Stack';
import {
    parseJSONValue,
    parseJSONObject,
    parseJSONArray,
    parseString
} from "parse-json-object";
import { UiButton } from '../../_uiComponents/common/form/UiButton';
import UiSearch from "../../_uiComponents/common/form/UiSearch";
import { dataUploadDataProcessingRecodeRequest, dataUploadSummeryRequest } from '../../../_redux/_actions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export default function JsonViewDataTable(props) {

    const actionDispatch = useDispatch();
    const {dataUploadSummery } = useSelector((state) => {
        return {
            dataUploadSummery: state.dataUpload.dataUploadSummery
        };
    });

    const [openList, setOpenList] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const [keyword, setKeyword] = React.useState('');
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [active, setActive] = React.useState();

   
    const searchSummaryFunc = (row ,keyword) => {
        actionDispatch(dataUploadSummeryRequest({
            id: row,
            page: page,
            pageSize: rowsPerPage,
            keyword:keyword? keyword:null
        }
        ))
    }


    const dataUploadHandle = (clickedIndex) => {
        if (active === clickedIndex) {
            setActive(null);
            setOpenList(true);
        } else {
            setActive(clickedIndex);
            setOpenList(true);
        }
    };

    useEffect(() => {
        if(props.currentCheck === null){
            searchSummaryFunc(props.rowId, keyword);
        }else {
            actionDispatch(dataUploadDataProcessingRecodeRequest({
                DataProcessingId: props?.dataTableStatus?.id ? props?.dataTableStatus?.id : 1,
                statusId: props?.status,
                page: page,
                pageSize: rowsPerPage,
            }
            ))
        }
    }, [page, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1); 

   };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(1);
   };

    return (
        <>
            <div className='sb-data-upload-inner-search'>
                <UiSearch
                 onChange={(e)=>{
                    setKeyword(e);
                    searchSummaryFunc(props.rowId,e);
                 }}
                />
            </div>
            <Table sx={{ minWidth: 650, mt: 1 }}>
                <TableBody>

                    {dataUploadSummery?.recordsList && dataUploadSummery.recordsList.map((item, index) => (
                        <TableRow>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 0, paddingRight: 0, background: '#f9f8f8', border: 'none' }} colSpan={12}>
                                <div className="sba-data-upload-summary-records"
                                    onClick={() => { dataUploadHandle(index) }}
                                >
                                    <span className='sba-data-upload-name'>
                                        {active == index && openList ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        <span style={{ fontWeight: 'bold' }}>{item?.identityColumn} : {item?.identityValue}</span>
                                    </span>
                                    <span className='sba-data-upload-status'>
                                        {item?.status === 'Success' ?
                                            <span className="sba-dataupload-file-success">Success</span> :
                                            <span className="sba-dataupload-file-failed">Failed</span>}
                                    </span>
                                    {/* <span>status</span> */}
                                </div>
                                <Collapse in={active == index && openList} timeout="auto" unmountOnExit>
                                    <Grid container spacing={2} >
                                        <Grid item xs={12} lg={5}>
                                            <div className='sba-upload-json-view'>
                                                <JsonView
                                                    src={parseJSONObject(item?.dataObject)}
                                                    editable={{ delete: false, edit: true }}
                                                    onEdit={params => {

                                                    }} />
                                            </div>
                                        </Grid>
                                        {item?.errorList?.length !== 0 &&
                                            <Grid item xs={12} lg={7} >
                                                <div className='sba-upload-error-list'>
                                                    <h5>Error List</h5>
                                                    <ul>
                                                        {item?.errorList.map((item, index) => (
                                                            <li key={index}>{item}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </Grid>
                                        }

                                    </Grid>
                                    {/* <Grid container sx={{ display: 'flex', textAlign: 'right', mt: 2, mb: 2 }} >
                                        <Grid item xs={12} lg={12} >
                                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                                                <UiButton name="Clear" variant="outlined" size="large" />
                                                <UiButton disabled={item.statusId!=2}  name="Edit" variant="contained" size="large" />
                                            </Stack>

                                        </Grid>
                                    </Grid> */}

                                </Collapse>
                            </TableCell>
                        </TableRow>

                    ))}
                    {dataUploadSummery?.recordsList && dataUploadSummery?.recordsList.length === 0 &&

                        <TableRow>
                            <TableCell style={{ paddingBottom: 0, textAlign: 'center', paddingTop: 0, paddingLeft: 0, paddingRight: 0, background: '#f0f0f0', border: 'none' }} colSpan={12}>
                                <h5 className='sba-empty-records'>No Records</h5>
                            </TableCell>
                        </TableRow>
                    }

                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={dataUploadSummery?.totalRecords ? dataUploadSummery?.totalRecords : 0}
                rowsPerPage={rowsPerPage}
                page={page - 1}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />


        </>
    )
}
